import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const FadeUp = ({ children, delay = 0, y = 32, className = "", once = true }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once, amount: 0.15 }}
        transition={{ duration: 0.8, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0, inView = false }) => {
    const anim = { opacity: 1, y: 0 };
    const initial = { opacity: 0, y: "110%" };
    const props = inView
        ? { initial, whileInView: anim, viewport: { once: true, amount: 0.4 } }
        : { initial, animate: anim };
    return (
        <span className={className}>
            {lines.map((line, i) => (
                <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
                    <motion.span
                        {...props}
                        transition={{ duration: 1, delay: delay + i * 0.1, ease: EASE }}
                        className={`block will-change-transform ${lineClassName}`}
                    >
                        {line}
                    </motion.span>
                </span>
            ))}
        </span>
    );
};

export const Page = ({ children, className = "" }) => (
    <motion.main
        className={className}
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: EASE }}
    >
        {children}
    </motion.main>
);

export const SectionHead = ({ eyebrow, title, sub, align = "left", light = false }) => (
    <FadeUp className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
        <p className={`flex items-center gap-3 text-[11px] md:text-xs font-mono uppercase tracking-[0.3em] text-gold ${align === "center" ? "justify-center" : ""}`}>
            <span className={`stitch-x inline-block w-10 ${align === "center" ? "" : ""}`} />
            {eyebrow}
        </p>
        <h2 className={`mt-4 ${light ? "text-stroke" : ""}`}>
            <span
                className="denim-bg relative inline-block overflow-hidden rounded-sm border border-gold/25 px-4 py-2 md:px-5 md:py-3"
                style={{ backgroundImage: "url('/img/denim/denim-texture.jpg')" }}
            >
                <span className="pointer-events-none absolute inset-0 bg-obsidian/55" aria-hidden="true" />
                <span className="pointer-events-none absolute inset-1.5 rounded-sm border border-dashed border-gold/40" aria-hidden="true" />
                <span className="relative z-10 block font-display text-2xl font-bold uppercase leading-[1.1] tracking-tight text-ink [text-shadow:0_2px_0_rgba(0,0,0,0.65)] sm:text-3xl md:text-4xl lg:text-5xl">
                    {title}
                </span>
            </span>
        </h2>
        {sub ? <p className="mt-4 text-base text-mute leading-relaxed">{sub}</p> : null}
    </FadeUp>
);
